import React from "react";
import MovieList from "./MovieList";
import { useSelector } from "react-redux";

const SecondaryContainer = () => {
	const movies = useSelector((store) => store.movies);

	return (
		movies && (
			<div className="secondary-container bg-black px-4 mt-8 md:mt-0">
				<div className="[@media(width<=550px)]:mt-0 -mt-[10%] md:-mt-[15%] z-[1] relative flex flex-col gap-12 lg:gap-16 pb-[100px] md:pb-[150px]">
					<MovieList
						title={"Now Playing"}
						movies={movies.nowPlayingMovies}
						isGptMovies={false}
					/>
					<MovieList
						title={"Top Rated"}
						movies={movies.topRatedMovies}
						isGptMovies={false}
					/>
					<MovieList
						title={"Upcoming Movies"}
						movies={movies.upcomingMovies}
						isGptMovies={false}
					/>
					<MovieList
						title={"Popular Movies"}
						movies={movies.popularMovies}
						isGptMovies={false}
					/>
				</div>
			</div>
		)
	);
};

export default SecondaryContainer;
